import { CalendarPayloadResolver } from "@ihr-radioedit/inferno-core";

import { filterEventDates } from "../../lib/calendar";
import { DATETIME_DISPLAY_FORMATS, zonedTimeFormat } from "../../lib/time";

interface CalendarTitleParams {
  payload:
    | (ReturnType<typeof CalendarPayloadResolver.decode> extends infer R
        ? R extends { right: infer P }
          ? P
          : never
        : never)
    | null;
  contentTitle: string;
  blockTitle: string;
  stationName: string;
  timezone: string;
}

interface CalendarTitleResult {
  title: string;
  socialTitle: string;
  eventDate: string | null;
}

export function buildCalendarTitles({
  payload,
  contentTitle,
  blockTitle,
  stationName,
  timezone,
}: CalendarTitleParams): CalendarTitleResult {
  let title = payload?.fields.seo_title?.value || contentTitle || "";

  if (title) {
    title = `${title} | ${stationName}`;
  }

  const venue = payload?.fields.venue_name?.value || "";
  const seoTitle = payload?.fields.social_title?.value || blockTitle || "";

  const eventDateValue =
    filterEventDates(payload?.fields.event_date?.value ?? [])[0] ?? payload?.fields.event_date?.value[0];
  let eventDate: string | null = null;

  if (eventDateValue?.begin && !payload?.fields.hide_event_date?.value) {
    eventDate = zonedTimeFormat({
      date: eventDateValue?.begin,
      timezone,
      outputFormat: DATETIME_DISPLAY_FORMATS.SHORT_MONTH_DAY_WITH_SUFFIX_FULL_YEAR,
    });
  }

  if (seoTitle) {
    if (eventDate && venue) {
      title = `${seoTitle} | ${eventDate} | ${venue} | ${stationName}`;
    } else {
      title = `${seoTitle} | ${stationName}`;
    }
  }

  let socialTitle = payload?.fields.social_title?.value
    ? `${payload.fields.social_title.value} | ${stationName}`
    : title;

  if ((payload?.fields.social_title?.value || !seoTitle) && eventDate && venue) {
    socialTitle = `${socialTitle} | ${eventDate} | ${venue}`;
  }

  return { title, socialTitle, eventDate };
}
